(() => {
  const script = document.currentScript;
  const currency = script && script.dataset.currency;
  const prefixes = {
    AUD: 'A$',
    CAD: 'CA$'
  };
  const compactPrefixes = {
    AUD: 'A$',
    CAD: 'C$'
  };
  const countries = {
    AUD: 'AU',
    CAD: 'CA'
  };
  const prefix = prefixes[currency];
  const compactPrefix = compactPrefixes[currency];

  if (!prefix) return;

  const marketDollar = new RegExp(`\\b(?:${currency}|${countries[currency]})\\s*\\$(?=\\s*\\d)`, 'g');
  const compactDollar = new RegExp(`\\b${compactPrefix.replace('$', '\\$')}(?=\\s*\\d)`, 'g');
  const prefixFragments = [countries[currency], compactPrefix.slice(0, -1)]
    .filter((value, index, values) => values.indexOf(value) === index)
    .sort((a, b) => b.length - a.length);
  const duplicateDollar = new RegExp(`\\b(?:(?:${prefixFragments.join('|')})\\s*){2,}\\$(?=\\s*\\d)`, 'g');
  const splitPrefixFragments = new Set(prefixFragments);
  const splitPrefixSuffix = new RegExp(`(^|\\s)(?:${prefixFragments.join('|')})\\s*$`);
  const currencyAfterAmount = new RegExp(`(${prefix.replace('$', '\\$')}\\s*\\d(?:[\\d.,'\\u00a0 ]*\\d)?)\\s+${currency}\\b`, 'g');
  const plainDollar = /(^|[^A-Za-z])\$(?=\s*\d)/g;
  const excludedParents = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const priceSelector = '.money, .transcy-money, [class*="price"], [data-price], [data-fg-price], [data-aircast-sticky-price]';

  function formatCurrency(value) {
    return value
      .replace(duplicateDollar, prefix)
      .replace(marketDollar, prefix)
      .replace(compactDollar, prefix)
      .replace(plainDollar, `$1${prefix}`)
      .replace(currencyAfterAmount, '$1');
  }

  function removeSplitDuplicatePrefix(node) {
    if (!node.nodeValue.trim().startsWith(prefix)) return;

    let current = node;
    while (current.parentNode && current.parentNode !== document.body) {
      let previous = current.previousSibling;
      while (previous && previous.nodeType === Node.TEXT_NODE && !previous.nodeValue.trim()) {
        previous = previous.previousSibling;
      }

      if (previous) {
        if (
          previous.nodeType === Node.TEXT_NODE &&
          previous.parentElement &&
          previous.parentElement.closest(priceSelector)
        ) {
          const fragment = previous.nodeValue.match(splitPrefixSuffix);
          if (fragment && splitPrefixFragments.has(fragment[0].trim())) {
            previous.nodeValue = previous.nodeValue.replace(splitPrefixSuffix, '$1');
          }
        }
        return;
      }

      current = current.parentNode;
    }
  }

  function updateTextNode(node) {
    if (!node.nodeValue || !node.nodeValue.includes('$')) return;
    if (!node.parentElement || excludedParents.has(node.parentElement.tagName)) return;
    if (node.parentElement.closest('[contenteditable="true"]')) return;

    const formatted = formatCurrency(node.nodeValue);
    if (formatted !== node.nodeValue) node.nodeValue = formatted;
    removeSplitDuplicatePrefix(node);
  }

  function updateTree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      updateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      updateTextNode(node);
      node = walker.nextNode();
    }
  }

  updateTree(document.body);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        updateTextNode(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(updateTree);
    });
  }).observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
